import { render } from "./main_page.vue?vue&type=template&id=825d34a0"
import script from "./main_page.vue?vue&type=script&lang=js"
export * from "./main_page.vue?vue&type=script&lang=js"

import "./main_page.vue?vue&type=style&index=0&id=825d34a0&lang=stylus"

import exportComponent from "/Users/o.borysenko/Documents/Lokal Google Drive/PARTNERKA/Betting_landing_cybersport/betting_cybersport/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__